import styled from "styled-components";
import { Colors } from "../../../common/colors/colors";

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 20px;
	gap: 20px;
`;

export const TableTitle = styled.h3`
	width: 100%;
	color: ${Colors.darkBlue};
	margin: 20px 4px 10px;
	cursor: pointer;
	display: flex;
	align-items: center;
`;

export const QueueTableWrapper = styled.div`
	opacity: ${(props) => (props.show ? 1 : 0.1)};
	overflow: hidden;
	height: ${(props) => (props.show ? 'fit-content' : '100px')};
	transition: all 0.3s;
`;

export const ShowArrow = styled.i`
	display: inline-block;
	width: 8px;
	height: 8px;
	border: solid ${Colors.darkBlue};
	border-width: 0 2.5px 2.5px 0;
	margin-left: 12px;
	margin-bottom: 0;
	transition: transform 0.3s ease-in-out;
	transform: ${(props) => (props.show ? 'rotate(45deg)' : 'rotate(-135deg)')};
	cursor: pointer;
`;